import StatusTimer from '../components/StatusTimer/StatusTimer';
import PhoneHandIllustration from '../components/Illustrations/PhoneHandIllustration';
import { useLanguageContext } from '../core/locale/LanguageContext';
import type { StatusViewChildProps } from './StatusView.types';

const StatusViewRedesigned = ({
  phoneNumber,
  expiresAt,
  startTime,
}: StatusViewChildProps): React.ReactNode => {
  const languageContext = useLanguageContext();

  return (
    <>
      <div className="status-view-illustration-wrapper">
        <PhoneHandIllustration className="status-view-illustration-image" />
      </div>
      <StatusTimer expiresAt={expiresAt} startTime={startTime} />
      <div className="status-view-header">
        <h1 className="status-view-heading">{languageContext.getLocalizedText('statusHeader')}</h1>
        <p className="status-view-description">
          {languageContext.getLocalizedText('statusContent', phoneNumber)}
        </p>
      </div>
    </>
  );
};

export default StatusViewRedesigned;
